// @vendors
import { Navigate, Outlet } from "react-router-dom";

// @types
import { UserRole } from '../../types/auth.types';

// @hooks
import { useAuth } from "../../hooks/useAuth";

// @config
import routesConfig from "../../config/routes.config";

interface ProtectedRouteProps {
    allowedRoles: UserRole[];
    redirectTo?: string;
}

export const ProtectedRoute = ({
    allowedRoles,
    redirectTo = routesConfig.home,
}: ProtectedRouteProps) => {
    const { checkAccess, isLoading } = useAuth();

    if (isLoading) {
        return <div>Cargando...</div>;
    }

    return checkAccess(allowedRoles) ? <Outlet /> : <Navigate to={redirectTo} replace />;
};